import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "../admin/pages/authentication/SignIn";
import ForgotPassword from "../admin/pages/authentication/ForgotPassword";
import EmailVerify from "../users/templates/otpTemplates/EmailVerify";
import AdminLayout from "./AdminLayout";
import PrivateRoutes from "./PrivateRoutes";
import AdminUser from "../admin/pages/user/AdminUser";
import UserForm from "../admin/pages/user/UserForm";
import Page404 from "../common/pages/Page404";
import PublicLayout from "./PublicLayout";
import HomeSection1 from "../admin/pages/homesection/section1/HomeSection1";
import ChatBotTabel from "../admin/pages/chatbot/ChatBotTabel";
import ChatBotForm from "../admin/pages/chatbot/ChatBotForm";
import SocialMediaAdmin from "../admin/pages/socialmedia/SocialMediaAdmin";
import Allpages from "../users/pages/Allpages";
import AdminColourChange from "../admin/pages/about/AdminColourChange";
import AdminDiscoverSection from "../admin/pages/about/AdminDiscoverSection";
import AdminAboutClientText from "../admin/pages/about/AdminAboutClientText";
import NewsSection from "../users/pages/components/news/NewsSection";
import Carrer from "../users/pages/components/carrer/Carrer";
import ProductImages from "../users/pages/components/product/ProductImages";
import AdminScroolCard from "../admin/pages/homesection/scroolcard/AdminScroolCard";
import AdminScroolForm from "../admin/pages/homesection/scroolcard/AdminScroolForm";
import HomeSection1Form from "../admin/pages/homesection/section1/HomeSection1Form";
import AdminTimeline from "../admin/pages/about/timeline/AdminTimeline";
import AdminTimelineform from "../admin/pages/about/timeline/AdminTimelineform";
import TopMarque from "../admin/pages/about/marque/TopMarque";
import MarqueForm from "../admin/pages/about/marque/MarqueForm";
import BottomMarque from "../admin/pages/about/marque/BottomMarque";
import AdmincaseStudy from "../admin/pages/casestudy/AdmincaseStudy";
import AdmincaseStudyForm from "../admin/pages/casestudy/AdmincaseStudyForm";
import AdminAllproduct from "../admin/pages/product/allproduct/AdminAllproduct";
import AdminAllproductForm from "../admin/pages/product/allproduct/AdminAllproductForm";
import AdminProductViewtext from "../admin/pages/product/viewtext/AdminProductViewtext";
import AdminFacilitiesTabel from "../admin/pages/facilites/AdminFacilitiesTabel";
import AdminFacilitiesForm from "../admin/pages/facilites/AdminFacilitiesForm";
import Expertise from "../users/pages/components/expertise/Expertise";
import FacilitiesBox from "../users/pages/components/facilities/FacilitiesBox";
import CarrerDetails from "../users/pages/components/carrer/carrerDeatils/CarrerDetails";
import AdminExpertise from "../admin/pages/expertise/AdminExpertise";
import AdminExpertiseForm from "../admin/pages/expertise/AdminExpertiseForm";
import AdminCarrerTabel from "../admin/pages/carrer/AdminCarrerTabel";
import AdminCarrerForm from "../admin/pages/carrer/AdminCarrerForm";
import AdminBanner from "../admin/pages/banner/AdminBanner";
import AdminNewsCardForm from "../admin/pages/newsroom/card/AdminNewsCardForm";
import AdminNewsCard from "../admin/pages/newsroom/card/AdminNewsCard";
import AdminNewsCarsoul from "../admin/pages/newsroom/carsoul/AdminNewsCarsoul";
import AdminNewsCarsoulForm from "../admin/pages/newsroom/carsoul/AdminNewsCarsoulForm";
import AdminCubeTabel from "../admin/pages/about/cube/AdminCubeTabel";
import AdminCubeForm from "../admin/pages/about/cube/AdminCubeForm";
import SoacialmediaForm from "../admin/pages/socialmedia/SoacialmediaForm";
import AdminPrivacy from "../admin/pages/about/privacy/AdminPrivacy";
import AdminPrivacyForm from "../admin/pages/about/privacy/AdminPrivacyForm";
import AdminBrochure from "../admin/pages/brochure/AdminBrochure";
import AdminBrochureForm from "../admin/pages/brochure/AdminBrochureForm";
import ApplyForm from "../users/pages/components/carrer/form/ApplyForm";
import AdminDashboard from "../admin/pages/dashboard/AdminDashboard";
import BrochureList from "../users/pages/components/product/brochure/BrochureList";
import Faq from "../users/pages/components/faq/Faq";
import EnquireTabel from "../admin/pages/enquireform/EnquireTabel";
import ApplicationDetails from "../admin/pages/application/ApplicationDetails";
import AdminContactTabel from "../admin/pages/contact/Contact";
import AdminContactAdd from "../admin/pages/contact/Contact";
import ConformPassword from "../admin/pages/authentication/ConformPassword";
import RouteScroolTop from "./RouteScroolTop";
import Home from "../users/pages/components/home/Home";
import About from "../users/pages/components/about/About";
import CaseStudy from "../users/pages/components/caseStudies/CaseStudy";
import Product from "../users/pages/components/product/Product";
import Contact from "../users/pages/components/contact/Contact";
import NewProduct from "../users/pages/components/product/NewProduct";
import Teams from "../users/pages/components/teams/Teams";
import Certification from "../users/pages/components/certification/Certification";
import AdminTeamsForm from "../admin/pages/teams/AdminTeamsForm";
import AdminTeamsTabel from "../admin/pages/teams/AdminTeamsTabel";
import AdminCertification from "../admin/pages/certification/AdminCertification";
import AdminCertificationForm from "../admin/pages/certification/AdminCertificationForm";
import AdminImageGallery from "../admin/pages/imageGallery/AdminImageGallery";
import AdminImageGalleryForm from "../admin/pages/imageGallery/AdminImageGalleryForm";
import ImageGallery from "../users/pages/components/imagegallery/ImageGallery";

const RoutesPage = () => {
  return (
    <>
      {/* <RouteScroolTop /> */}
      <Routes>
        {/* Public Routes */}
        <Route
          exact
          path="/"
          element={
            <PublicLayout>
              <Home />
            </PublicLayout>
          }
        />
        <Route
          exact
          path="/about"
          element={
            <PublicLayout>
              <About />
            </PublicLayout>
          }
        />
        <Route
          exact
          path="/casestudies"
          element={
            <PublicLayout>
              <CaseStudy />
            </PublicLayout>
          }
        />
        <Route
          exact
          path="/products"
          element={
            <PublicLayout>
              <NewProduct />
            </PublicLayout>
          }
        />
        <Route
          exact
          path="/contact"
          element={
            <PublicLayout>
              <Contact />
            </PublicLayout>
          }
        />
        <Route
          path="/newssection"
          exact
          element={
            <PublicLayout>
              <NewsSection />
            </PublicLayout>
          }
        />

        <Route
          path="/allproduct"
          exact
          element={
            <PublicLayout>
              <ProductImages />
            </PublicLayout>
          }
        />
        <Route
          path="/careers"
          exact
          element={
            <PublicLayout>
              <Carrer />
            </PublicLayout>
          }
        />
        <Route
          path="/careers/deatils/:id"
          exact
          element={
            <PublicLayout>
              <CarrerDetails />
            </PublicLayout>
          }
        />
        <Route
          path="/expertise"
          exact
          element={
            <PublicLayout>
              <Expertise />
            </PublicLayout>
          }
        />
        <Route
          path="/facilities"
          exact
          element={
            <PublicLayout>
              <FacilitiesBox />
            </PublicLayout>
          }
        />
        <Route
          path="/teams"
          exact
          element={
            <PublicLayout>
              <Teams />
            </PublicLayout>
          }
        />
        <Route
          path="/certification"
          exact
          element={
            <PublicLayout>
              <Certification />
            </PublicLayout>
          }
        />
        <Route
          path="/gallery"
          exact
          element={
            <PublicLayout>
              <ImageGallery />
            </PublicLayout>
          }
        />
        <Route
          path="*"
          element={
            <PublicLayout>
              <Page404 />
            </PublicLayout>
          }
        />
        <Route
          path="/admin"
          element={
            <PublicLayout>
              <SignIn />
            </PublicLayout>
          }
        />
        <Route
          path="/forgotpassword"
          element={
            <PublicLayout>
              <ForgotPassword />
            </PublicLayout>
          }
        />
        <Route
          path="/emailverify"
          element={
            <PublicLayout>
              <EmailVerify />
            </PublicLayout>
          }
        />
        <Route
          path="/confirmPassword/:token"
          element={
            <PublicLayout>
              <ConformPassword />
            </PublicLayout>
          }
        />
        <Route
          path="/apply-form/:id"
          element={
            <PublicLayout>
              <ApplyForm />
            </PublicLayout>
          }
        />
        <Route
          path="/allbrocedure"
          element={
            <PublicLayout>
              <BrochureList />
            </PublicLayout>
          }
        />
        <Route
          path="/faq"
          element={
            <PublicLayout>
              <Faq />
            </PublicLayout>
          }
        />
        <Route path="/page-not" element={<Page404 />} />

        {/* Protected Admin Routes */}
        <Route
          path="/admin/*"
          element={
            <PrivateRoutes>
              <AdminLayout />
            </PrivateRoutes>
          }
        >
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="user" element={<AdminUser />} />
          <Route path="faq" element={<ChatBotTabel />} />
          <Route path="faq/add" element={<ChatBotForm />} />
          <Route path="brocedure" element={<AdminBrochure />} />
          <Route path="enquireform" element={<EnquireTabel />} />
          <Route path="dashboard/enquireform" element={<EnquireTabel />} />
          <Route path="applicationForm" element={<ApplicationDetails />} />
          <Route path="brocedure/add" element={<AdminBrochureForm />} />
          <Route path="brocedure/edit/:id" element={<AdminBrochureForm />} />
          <Route path="socialmedia" element={<SocialMediaAdmin />} />
          <Route path="socialmedia/edit/:id" element={<SoacialmediaForm />} />
          <Route path="faq/edit/:id" element={<ChatBotForm />} />
          <Route path="user/add" element={<UserForm />} />
          <Route path="user/edit/:id" element={<UserForm />} />
          <Route path="home/imagecarsoul" element={<HomeSection1 />} />
          <Route path="home/imagecarsoul/add" element={<HomeSection1Form />} />
          <Route
            path="home/imagecarsoul/edit/:id"
            element={<HomeSection1Form />}
          />
          <Route path="home/scroolcard" element={<AdminScroolCard />} />
          <Route path="home/scroolcard/add" element={<AdminScroolForm />} />
          <Route
            path="home/scroolcard/edit/:id"
            element={<AdminScroolForm />}
          />
          <Route path="about/rotatecube" element={<AdminCubeTabel />} />
          <Route path="about/rotatecube/edit/:id" element={<AdminCubeForm />} />
          <Route path="about/aboutsection2" element={<AdminColourChange />} />
          <Route
            path="about/aboutsection3"
            element={<AdminDiscoverSection />}
          />
          <Route
            path="about/aboutsection4"
            element={<AdminAboutClientText />}
          />
          <Route path="about/privacy" element={<AdminPrivacy />} />
          <Route path="about/privacy/add" element={<AdminPrivacyForm />} />
          <Route path="about/privacy/edit/:id" element={<AdminPrivacyForm />} />
          <Route path="about/timeline" element={<AdminTimeline />} />
          <Route path="about/timeline/add" element={<AdminTimelineform />} />
          <Route
            path="about/timeline/edit/:id"
            element={<AdminTimelineform />}
          />
          <Route path="about/marquetop" element={<TopMarque />} />
          <Route path="about/marquebottom" element={<BottomMarque />} />
          <Route path="about/marquetop/add" element={<MarqueForm />} />
          <Route path="about/marquetop/edit/:id" element={<MarqueForm />} />
          <Route path="casestudy" element={<AdmincaseStudy />} />
          <Route path="casestudy/add" element={<AdmincaseStudyForm />} />
          <Route path="casestudy/edit/:id" element={<AdmincaseStudyForm />} />
          <Route path="products/allproducts" element={<AdminAllproduct />} />
          <Route
            path="products/allproducts/add"
            element={<AdminAllproductForm />}
          />
          <Route
            path="products/allproducts/edit/:id"
            element={<AdminAllproductForm />}
          />
          <Route path="products/viewtext" element={<AdminProductViewtext />} />
          <Route path="facilities" element={<AdminFacilitiesTabel />} />
          <Route path="facilities/add" element={<AdminFacilitiesForm />} />
          <Route path="facilities/edit/:id" element={<AdminFacilitiesForm />} />
          <Route path="expertise" element={<AdminExpertise />} />
          <Route path="expertise/add" element={<AdminExpertiseForm />} />
          <Route path="expertise/edit/:id" element={<AdminExpertiseForm />} />
          <Route path="carrer" element={<AdminCarrerTabel />} />
          <Route path="contact" element={<AdminContactAdd />} />
          <Route path="teams" element={<AdminTeamsTabel />} />
          <Route path="teams/add" element={<AdminTeamsForm />} />
          <Route path="teams/edit" element={<AdminTeamsForm />} />
          <Route path="imagegallery" element={<AdminImageGallery />} />
          <Route path="imagegallery/add" element={<AdminImageGalleryForm />} />
          <Route path="imagegallery/edit" element={<AdminImageGalleryForm />} />
          <Route path="certification" element={<AdminCertification />} />
          <Route
            path="certification/add"
            element={<AdminCertificationForm />}
          />
          <Route
            path="certification/edit"
            element={<AdminCertificationForm />}
          />
          <Route path="carrer/add" element={<AdminCarrerForm />} />
          <Route path="carrer/edit/:id" element={<AdminCarrerForm />} />
          <Route path="banner" element={<AdminBanner />} />
          <Route path="newscard" element={<AdminNewsCard />} />
          <Route path="newscard/add" element={<AdminNewsCardForm />} />
          <Route path="newscard/edit/:id" element={<AdminNewsCardForm />} />
          <Route path="newscarsoul" element={<AdminNewsCarsoul />} />
          <Route path="newscarsoul/add" element={<AdminNewsCarsoulForm />} />
          <Route
            path="newscarsoul/edit/:id"
            element={<AdminNewsCarsoulForm />}
          />

          <Route path="*" element={<Page404 />} />
        </Route>
      </Routes>
    </>
  );
};

export default RoutesPage;
